import React, { useState, useRef, useEffect } from 'react';

export default function AdminLogin({ onLogin, error, busy }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const emailRef = useRef(null);

  useEffect(() => { emailRef.current?.focus(); }, []);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !password || busy) return;
    onLogin(email.trim(), password);
  };

  return (
    <div className="ck-admin-login">
      <div className="ck-admin-login__card">
        <div className="ck-admin-login__brand">
          <img src={process.env.PUBLIC_URL + '/assets/nav-logo.png'} alt="C-Kan" />
          <span>Admin</span>
        </div>

        <h1 className="ck-admin-login__title">Acceso restringido</h1>
        <p className="ck-admin-login__lede">
          Ingresa tu correo y contraseña para administrar los eventos.
        </p>

        <form onSubmit={submit} className="ck-admin-login__form" noValidate autoComplete="off">
          {/* Email */}
          <label className="ck-admin-field">
            <span className="ck-admin-field__label">Correo electrónico</span>
            <div className="ck-admin-field__input-wrap">
              <input
                ref={emailRef}
                type="email"
                inputMode="email"
                name="ck-admin-email"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                data-lpignore="true"
                data-1p-ignore="true"
                data-form-type="other"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="ck-admin-field__input"
                disabled={busy}
                placeholder="tu@email.com"
              />
            </div>
          </label>

          {/* Password */}
          <label className="ck-admin-field">
            <span className="ck-admin-field__label">Contraseña</span>
            <div className="ck-admin-field__input-wrap">
              <input
                type={show ? 'text' : 'password'}
                name="ck-admin-pwd"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                data-lpignore="true"
                data-1p-ignore="true"
                data-form-type="other"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="ck-admin-field__input"
                disabled={busy}
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShow(s => !s)}
                className="ck-admin-field__toggle"
                aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                tabIndex={-1}
              >
                <i className={show ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'} />
              </button>
            </div>
          </label>

          {error && (
            <p className="ck-admin-login__error">
              <i className="fa-solid fa-circle-exclamation" /> {error}
            </p>
          )}

          <button
            type="submit"
            className="ck-admin-btn ck-admin-btn--primary"
            disabled={busy || !email || !password}
          >
            {busy ? 'Verificando…' : 'Iniciar sesión'}
            {!busy && (
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            )}
          </button>

          <a href="/" className="ck-admin-login__back">← Volver al sitio</a>
        </form>
      </div>

      <div className="ck-admin-login__note">
        Sesión protegida · Acceso autorizado únicamente
      </div>
    </div>
  );
}
